import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";

import {
  useCreateProductUpdateMutation,
  useGetProductUpdateQuery,
  useUpdateProductUpdateMutation,
} from "api/memberPortal/product/productUpdate/productUpdate.api";
import { ProductUpdate } from "api/memberPortal/product/productUpdate/productUpdate.types";

import ProductUpdateBaseModal from "./ProductUpdateBase.modal";

interface ProductUpdateModalProps {
  editMode?: boolean;
}

const ProductUpdateModal = ({ editMode }: ProductUpdateModalProps) => {
  const { id: parentId, updateId } = useParams();
  const pathParams = updateId && parentId ? { parentId, updateId } : undefined;

  const { data: currentUpdate } = useGetProductUpdateQuery(
    pathParams ?? skipToken,
    {
      skip: !editMode,
    },
  );

  const [triggerCreate] = useCreateProductUpdateMutation();
  const [triggerEdit] = useUpdateProductUpdateMutation();

  return (
    <ProductUpdateBaseModal<ProductUpdate>
      editMode={editMode ?? false}
      onEdit={triggerEdit}
      onCreate={triggerCreate}
      currentUpdate={currentUpdate}
    />
  );
};
export default ProductUpdateModal;
